import AddIcon from '@mui/icons-material/Add';
import { Box, Button, GridLegacy as Grid, Snackbar, Typography } from '@mui/material';
import _ from 'lodash';
import React, { useState } from 'react';
import { useGetAllPreferences } from '../../services/react-query/preferences';
import { Preference, PREFERENCES_VALID_KEYS } from '../../types/Preference';
import { UserSettingsCollapseKeys } from '../../types/User';
import { Loading } from '../../uikit';
import PreferenceFormModal from './PreferenceFormModal';
import PreferenceItem from './PreferenceItem';
import { preferencesTableBox, preferencesTableHeaders } from './preferencesStyles';
import AccordionSection from '../AccordionSection';

interface IPreferencesTableProps {
  preferenceKey: PREFERENCES_VALID_KEYS;
  collapseId: UserSettingsCollapseKeys;
}

const PreferencesTableHeaders = (
  <Box sx={preferencesTableHeaders}>
    <Grid container>
      <Grid item container xs={12}>
        <Grid item xs={4}>
          <Typography>Value</Typography>
        </Grid>
        <Grid item sm={6}>
          <Typography>Description</Typography>
        </Grid>
        <Grid item md={2} sx={{ textAlign: 'center' }}>
          <Typography>Manage</Typography>
        </Grid>
      </Grid>
    </Grid>
  </Box>
);

const PreferencesTable = ({ preferenceKey, collapseId }: IPreferencesTableProps) => {
  const { data: preferences, isLoading: isGetAllPreferencesLoading } = useGetAllPreferences({
    params: { filters: { keys: [preferenceKey] } },
  });
  const [preferenceModalContent, setPreferenceModalContent] = useState<React.ReactNode | null>(null);
  const [snackbarMessage, setSnackbarMessage] = useState<string | null>(null);

  const openPreferenceModal = (uuid: string) => {
    setPreferenceModalContent(
      <PreferenceFormModal
        uuid={uuid}
        preferenceKey={preferenceKey}
        isOpen={true}
        onCancel={() => setPreferenceModalContent(null)}
        setPreferenceSnackbarMessage={setSnackbarMessage}
      />
    );
  };

  if (isGetAllPreferencesLoading) return <Loading />;

  return (
    <AccordionSection
      title={_.startCase(preferenceKey)}
      collapseId={collapseId}
      headerElements={
        <Button endIcon={<AddIcon />} variant="outlined" onClick={() => openPreferenceModal('new')}>
          New
        </Button>
      }
    >
      <Box sx={preferencesTableBox}>
        {PreferencesTableHeaders}
        {preferences?.map((preference: Preference) => (
          <PreferenceItem key={preference.uuid} preferenceKey={preferenceKey} preference={preference} setSnackbarMessage={setSnackbarMessage} />
        ))}
      </Box>
      {preferenceModalContent as React.ReactElement}
      <Snackbar open={!!snackbarMessage} onClose={() => setSnackbarMessage(null)} message={snackbarMessage} />
    </AccordionSection>
  );
};

export default PreferencesTable;
